import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_item_review_rating_config_hdr_RowInterface {

  guid: fromDatatype.GuidDataFieldInterface;
  sort_order: fromDatatype.NumericDatatypeInterface;
  is_active: fromDatatype.VarcharDatatypeInterface;
  module_guid:fromDatatype.GuidDataFieldInterface;
  applet_guid:fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status:fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date:fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  choices_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
}


export class bl_fi_item_review_rating_config_hdr_RowClass implements bl_fi_item_review_rating_config_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sort_order: fromDatatype.NumericDatatypeInterface;
  is_active: fromDatatype.VarcharDatatypeInterface;
  module_guid:fromDatatype.GuidDataFieldInterface;
  applet_guid:fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  status:fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date:fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  title: fromDatatype.VarcharDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  choices_json: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
}

